module.exports = "<!-- LOADER -->\r\n<div class=\"loading\" *ngIf=\"(loaderService.isLoading | async)\">Loading&#8230;</div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/loader/loader.component.html
// module id = ../../../../../src/app/helpers/components/loader/loader.component.html
// module chunks = main